/* eslint-disable max-classes-per-file */
import { SearchEntityType } from '@ftr/contracts/api/search'

export class FetchSearchManyResultsAction {
  static readonly type = '[SearchMany] Fetch Search Results'

  constructor(
    readonly searchTerms: string,
    readonly entities: SearchEntityType[],
    readonly courtSystemId: string,
    readonly pageToken: string | null,
  ) {}
}

export class FetchSearchEntityTypeToNumberOfMatchesAction {
  static readonly type = '[Search] Fetch Search Many Results Total Matches'

  constructor(
    public searchTerm: string,
    readonly entities: SearchEntityType[],
    readonly courtSystemId: string,
  ) {}
}
